import { useState } from "react";
import { Link } from "react-router-dom";

import { Avatar, Button, IconButton } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';

import AskDoubt from "../doubt/AskDoubt";
import { SnackbarNotification } from "../utils/Notifications";
import useAuth from "../../hooks/useAuth";

import "./css/navbar.css";

import dpSrc from "../../functions/dpSrc";
import nameToColor from "../../functions/nameToColor";
import { logout } from "../../functions/server-requests/user";

const Navbar = ({ isSiteInMaintenance }) => {
  const { auth, setAuth } = useAuth();
  const [openAskDoubt, setOpenAskDoubt] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");;
  const [message, setMessage] = useState("");

  const handleLogout = async () => {
    const logoutRes = await logout();

    if (logoutRes.status === 200) {
      setAuth({
        ...auth,
        isLoggedIn: false,
        userId: "",
        name: ""
      });

      setSeverity("success");
    }
    else {
      setSeverity("error");
    }

    setMessage(logoutRes.data.message);
    setOpenSnackbar(true);
  }

  return (
    <>
      <div className="navbar">
        <Link
          className="navbar-title-link"
          to="/"
        >
          DSolve
        </Link>

        {
          !isSiteInMaintenance &&
          <div className="navbar-right">
            {auth.isLoggedIn &&
              <div className="nr-ask-doubt">
                <Button
                  variant="outlined"
                  onClick={() => setOpenAskDoubt(true)}
                >
                  Ask Doubt
                </Button>
              </div>
            }

            {
              auth.isApiResCame &&
              <div>
                {auth.isLoggedIn
                  ? <div className="nr-user-info">
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`/profile/${auth.userId}`}
                    >
                      <Avatar
                        src={dpSrc(auth.userId)}
                        alt={auth.name}
                        sx={{
                          bgcolor: nameToColor(auth.name),
                          width: 48,
                          height: 48
                        }}
                      />
                    </Link>

                    <IconButton
                      sx={{ ml: "8px" }}
                      onClick={handleLogout}
                    >
                      <LogoutIcon />
                    </IconButton>
                  </div>
                  : <>
                    <Link
                      style={{
                        marginRight: "8px",
                        textDecoration: "none"
                      }}
                      to="/auth/signup"
                    >
                      <Button
                        variant="outlined"
                      >
                        Sign Up
                      </Button>
                    </Link>

                    <Link
                      style={{
                        textDecoration: "none"
                      }}
                      to="/auth/login"
                    >
                      <Button
                        variant="contained"
                      >
                        Login
                      </Button>
                    </Link>
                  </>
                }
              </div>
            }

          </div>
        }
      </div>

      <AskDoubt
        openAskDoubt={openAskDoubt}
        setOpenAskDoubt={setOpenAskDoubt}
      />

      <SnackbarNotification
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
        severity={severity}
        message={message}
      />
    </>
  );
}

export default Navbar;